/**
 * Headless host for the Hottie Voice graph.
 *
 * Attaches when kit sets `.hottr-hottie-layer[data-open="true"][data-mode="voice"]`.
 * Voice tab is the start. No chrome. No second button.
 */

import { useEffect } from 'react';
import {
  watchHottieVoiceAttach,
  watchVoiceOrbSlotGesture,
  watchVoiceTabGesture,
} from './voiceAttach';
import { startHottieVoiceGraph, stopHottieVoiceGraph } from './voiceSession';

export function useHottieVoiceGraph(): void {
  useEffect(() => {
    const stopGesture = watchVoiceTabGesture(() => {
      // Enter start on this turn. Do not await first — GUM is inside attachMic.
      startHottieVoiceGraph();
    });
    const stopOrb = watchVoiceOrbSlotGesture(() => {
      startHottieVoiceGraph();
    });
    const stopWatch = watchHottieVoiceAttach((attached) => {
      if (attached) startHottieVoiceGraph();
      else stopHottieVoiceGraph();
    });
    return () => {
      stopGesture();
      stopOrb();
      stopWatch();
      stopHottieVoiceGraph();
    };
  }, []);
}
